export default __webpack_public_path__ + "static/media/drop-red.0368fb63.svg";